import {
  buildAntdTheme,
  defaultTheme,
  SPACE_XL,
  SPACE_MD,
  SPACE_SM,
} from '@/theme/buildAntdTheme';

import type { CSSProperties } from 'react';

/** Auth surfaces are brand chrome: always the light palette, in every color scheme. */
export const AUTH_LIGHT_THEME = buildAntdTheme(defaultTheme, 'light');

export const AUTH_BANNER_PADDING = `${SPACE_XL + SPACE_MD}px ${SPACE_XL}px ${SPACE_XL}px ${SPACE_XL + SPACE_MD}px`;

export const AUTH_BANNER_GAP = SPACE_XL + SPACE_SM;

export const AUTH_TITLE_MAX_WIDTH = '12rem';

export const authPanelMotionStyle = (
  entered: boolean,
  prefersReducedMotion: boolean,
): CSSProperties =>
  prefersReducedMotion
    ? {}
    : {
        opacity: entered ? 1 : 0,
        transform: entered ? 'none' : 'translateY(12px)',
        transition: 'opacity 0.45s ease, transform 0.45s ease',
      };
